// ##############################
// // // students
// #############################
var IMGDIR = process.env.REACT_APP_IMGDIR;

const students = [
    {avatar: IMGDIR+"/images/university/students/student-9.jpg", name: "Lily White", position: "Architect", age: "23"},
    {avatar: IMGDIR+"/images/university/students/student-7.jpg", name: "Leah Young", position: "Electrical Engg", age: "23"},
    {avatar: IMGDIR+"/images/university/students/student-10.jpg", name: "Irene Smith", position: "Medical", age: "21"},
    {avatar: IMGDIR+"/images/university/students/student-3.jpg", name: "Julia Vasar", position: "Management", age: "25"},
    {avatar: IMGDIR+"/images/university/students/student-13.jpg", name: "Evan Short", position: "Mechnical Engg", age: "24"},
    {avatar: IMGDIR+"/images/university/students/student-1.jpg", name: "Fiona Vance", position: "Computer Engg", age: "20"},
    {avatar: IMGDIR+"/images/university/students/student-2.jpg", name: "Grace Turner", position: "Civil Engg", age: "21"},
    {avatar: IMGDIR+"/images/university/students/student-6.jpg", name: "Colin Taylor", position: "Aeronautical", age: "25"},
]; 

export {
    students, 
};
